import { Box, GridBoxList } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { TLocationsLocation } from 'modules/locations/hooks/useLocations'

import Item from './Item'

const Locations = ({ items }: { items: TLocationsLocation[] }) => {
  const centered = items.length < 2
  const multiple = items.length > 1

  return (
    <Box paddingTop="s40">
      {/* TODO: The GridBoxList has an arbitrary paddingTop of 40px, we need to remove it */}
      <GridBoxList centered={centered}>
        {items.map((location: TLocationsLocation) => (
          <Item
            key={location.id}
            location={location}
            multiple={multiple}
            extra={
              location.main ? { 'data-intercom-target': 'workplaces-main-location' } : undefined
            }
          />
        ))}
      </GridBoxList>
    </Box>
  )
}

export default observer(Locations)
